import React from "react";
import { ensure } from "sprint-common-web";

import { FileRecordListingItem } from "../../listing/types/FileRecordListingItem";
import { renderFileRecordStatusDetailsText } from "../components/status-details/FileRecordStatusDetailsText";

export const renderFileRecordStatusDetails = (item?: FileRecordListingItem): React.ReactElement | null => {
    ensure(item);

    return renderFileRecordStatusDetailsText({ statusDetails: item.statusDetails, fontSize: 12 });
};
